import { toastUtility, ToastPosition } from '@/utils/toastUtility';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef } from 'react';

const TOAST_POSITIONS: ToastPosition[] = [
  'top-left',
  'top-center',
  'top-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
  'center',
];

/**
 * Individual Toast wrapper that properly handles ref registration
 */
const PositionedToast: React.FC<{ position: ToastPosition }> = ({
  position,
}) => {
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    toastUtility.setToastRef(position, toastRef);

    return () => {
      toastUtility.clearToastRef(position);
    };
  }, [position]);

  return <Toast ref={toastRef} position={position} />;
};

/**
 * Toast container component
 * Renders PrimeReact Toast components for each position and registers them with the toast service
 */
export const ToastContainer: React.FC = () => {
  return (
    <>
      {TOAST_POSITIONS.map(position => (
        <PositionedToast key={position} position={position} />
      ))}
    </>
  );
};
